var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isMobile)?_c('div',{ref:"map",staticClass:"mobile",attrs:{"id":"map"}}):_c('div',{ref:"map",class:{ 'is-not-first-load-map': _vm.isFirstLoadMap === false },attrs:{"id":"map"}})
}
var staticRenderFns = []

export { render, staticRenderFns }